module.exports = __webpack_public_path__ + "static/media/zapsplat_household_door_front_large_heavy_wooden_open_54572.22b072cc.wav";